import { Action } from 'state/actions';
import { Thunk } from 'state/state.common';

export function dispatchAllThunk(actions: Action[]): Thunk {
  return dispatch => {
    actions.forEach(action => dispatch(action));
  };
}
